import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_file_by_id = (id) => {
  return api.post(
    `${ApiEndpointConstants.GETMODELBYID}`,
    {},
    { params: { id } }
  );
};
